import { Grid } from "@material-ui/core";
import React from "react";
import { Button, Modal } from "sunrise-ui";
// ---for API----
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../redux/store";
import {
  getProjectFinancialData,
  deleteProjectFinancialData,
} from "../../redux/reducers/projectReducers";
import { uiSliceActions } from "../../redux/reducers/uiState";
import Loader from "../../utilities/Loader";
import List from "../../utilities/List";


const MangeProjectFinancialInfo = () => {
  const dispatch = useDispatch<AppDispatch>();
  // -----------loader state------------
  let [loading, setLoading] = React.useState(false);
  //---to get all projects financial detail----
  React.useEffect(() => {
    setLoading(true);
    dispatch(
      getProjectFinancialData({
        endPoint: "project-finance/get-all-project-fin",
      })
    ).then((res) => {
      setLoading(false);
    });
  }, [dispatch]);
  const projectFinancialData = useSelector(
    (state: any) => state.PROJECT.getFinancialData
  );
  //---------------For Table------------------
  const [dataToDownload, setDataToDownload] = React.useState([]);

  React.useEffect(() => {
    if (projectFinancialData) {
      let list: any = [...projectFinancialData];
      list = list.map((val: any) => ({
        "Project Name": val.projectName,
        "Created At": val.createdAt,
        Month: val.month,
        "Overall Work Done": val.overallWorkDone,
        "Total Billing Done": val.totalBillingDone,
        "Total Payment Received": val.totalPaymentReceived,
        Description: val.description,
        "Updated At": val.updatedAt,
      }));
      setDataToDownload(list);
    }

    return;
  }, [projectFinancialData]);


  //-----modal state--------
  const [open, setOpen] = React.useState(false);
  const [modalText, setModalText] = React.useState("");
  const [handleCallData, setHandleCallData] = React.useState({
    type: "",
    financialInfoId: "",
    projectDetail: {},
  });
  //------modal handler
  const handleModal = (
    type: string,
    financialInfoId: string,
    projectDetail: any
  ) => {
    setOpen(true);
    setHandleCallData({
      type: type,
      financialInfoId: financialInfoId,
      projectDetail: projectDetail,
    });
    type === "edit"
      ? setModalText(
        "Are you sure you want to edit this project financial information?"
      )
      : setModalText(
        "Are you sure you want to remove this project financial information?"
      );
  };
  //----modal YES button handler
  const handleCall = () => {
    setOpen(false);
    if (handleCallData?.type === "remove") {
      //   --call delete api--
      setLoading(true);
      dispatch(
        deleteProjectFinancialData({
          endPoint: `project-finance/delete-project-fin/${handleCallData?.financialInfoId}`,
        })
      ).then((res) => {
        setLoading(false);
      });
      setTimeout(function () {
        setLoading(true);
        dispatch(
          getProjectFinancialData({
            endPoint: "project-finance/get-all-project-fin",
          })
        ).then((res) => {
          setLoading(false);
        });
      }, 1000);
    } else if (handleCallData?.type === "edit") {
      //   ---send edit data---
      dispatch(uiSliceActions.setFinancialEdit(handleCallData));
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  const actionButtons = function (obj: any) {
    return (
      <Grid className="action_buttons_box d-flex v-center">
        <Button
          type="button"
          size="medium"
          isRounded={true}
          category="primary"
          onClick={() => {
            handleModal("edit", obj?._id, obj);
          }}
          className="mr-1 f14"
        >
          Edit
        </Button>
        <Button
          type="button"
          size="medium"
          isRounded={true}
          category="warning"
          onClick={() => {
            handleModal("remove", obj?._id, obj);
          }}
          className="mr-1 f14"
        >
          Remove
        </Button>
      </Grid>
    );
  };

  const fields = [
    { header: "Project Name", value: "projectName", search: true },
    { header: "Month", value: "month", search: true },
    { header: "Year", value: "year", search: true },
    { header: "Payment Received (Rs)", value: "totalPaymentReceived", search: true },
    { header: "Billing Done (Rs)", value: "totalBillingDone", search: true },
    { header: "Work Done (Rs)", value: "overallWorkDone", search: true },
    { header: "Description", value: "description", search: true },
    { header: "Last Updated At", value: "updatedAt", search: true, format: 'date' },
    { header: "Action", action: actionButtons },
  ];


  return (
    <>
      {loading ? (
        <Loader color="#5f67e0" loading={loading} size={20} height="80vh" />
      ) : (
        <Grid
          container
          className="manage_financialInfo_wrapper"
        >
          {projectFinancialData &&
            <List
              listData={projectFinancialData}
              fields={fields}
              title={"Manage Project Financial Information"}
              dataToDownload={dataToDownload}
              isOverflow
            />}
          {/* -------modal---- */}
          <Grid item xs={12}>
            <Modal
              image="modalImage"
              call={() => {
                handleCall();
              }}
              reset={() => {
                setOpen(false);
              }}
              openModal={open}
              title={modalText}
              showImageModal={false}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default MangeProjectFinancialInfo;
